(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aube-dawn-scrubber"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aube-dawn-scrubber')) {
    customElements.define('aube-dawn-scrubber', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.range = this.querySelector('input');
        this.times = this.dataset.times.split(',').map(Number);
        this.columns = Number(this.dataset.columns) || 7;
        this.rows = Math.ceil(this.times.length / this.columns);
        this.output = this.querySelector('output');
        this.canvas = this.querySelector('canvas');
        this.context = this.canvas.getContext('2d', { alpha: false });
        this.hint = this.querySelector('.aube-dawn__hint');
        this.retry = this.querySelector('.aube-dawn__retry');
        this.range.addEventListener('input', () => { this.dataset.interacted = ''; this.render(); }, { signal: this.controller.signal });
        this.range.addEventListener('pointerdown', () => { this.dataset.interacted = ''; }, { signal: this.controller.signal });
        this.retry.addEventListener('click', () => this.load(), { signal: this.controller.signal });
        if (this.atlas) { this.render(); return; }
        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) this.dataset.visible = '';
            else delete this.dataset.visible;
          }, { threshold: 0.25 });
          this.visibilityObserver.observe(this.querySelector('.aube-dawn__controls'));
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) { this.observer.disconnect(); this.load(); }
          }, { rootMargin: '350px' });
          this.observer.observe(this);
        } else { this.dataset.visible = ''; this.load(); }
      }
      async load() {
        if (this.loading || this.atlas) return;
        this.loading = true;
        this.retry.hidden = true;
        this.hint.textContent = this.dataset.loading;
        const controller = this.controller;
        try {
          const atlas = new Image();
          atlas.decoding = 'async';
          atlas.src = window.matchMedia('(max-width: 699px)').matches ? (this.dataset.mobile || this.dataset.desktop) : this.dataset.desktop;
          if (!atlas.getAttribute('src')) throw new Error('Missing media');
          await atlas.decode();
          if (controller.signal.aborted) return;
          const cell = atlas.naturalWidth / this.columns;
          if (!cell || !Number.isInteger(cell) || atlas.naturalHeight !== cell * this.rows || !this.context) throw new Error('Invalid media');
          this.atlas = atlas;
          this.cell = cell;
          this.canvas.width = cell;
          this.canvas.height = cell;
          this.render();
          this.dataset.ready = '';
          this.range.disabled = false;
          this.hint.textContent = this.dataset.instruction;
        } catch (error) {
          if (!controller.signal.aborted) { this.hint.textContent = this.dataset.error; this.retry.hidden = false; }
        } finally { this.loading = false; }
      }
      render() {
        if (!this.atlas || !this.context) return;
        const index = Math.max(0, Math.min(this.times.length - 1, Math.round(Number(this.range.value))));
        this.context.drawImage(this.atlas, (index % this.columns) * this.cell, Math.floor(index / this.columns) * this.cell, this.cell, this.cell, 0, 0, this.cell, this.cell);
        const minutes = this.times[index];
        const time = `${Math.floor(minutes / 60)} h ${String(minutes % 60).padStart(2, '0')}`;
        this.output.value = time;
        this.range.setAttribute('aria-valuetext', time);
        this.range.style.setProperty('--progress', `${index / (this.times.length - 1) * 100}%`);
        this.dataset.frame = String(index);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.visibilityObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aube-review-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aube-review-cards')) {
    customElements.define('aube-review-cards', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track || this.controller) return;
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.navigation = this.querySelector('[data-navigation]');
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.controller = new AbortController();
        this.active = this.cards.length > 2 ? 1 : 0;
        const options = { signal: this.controller.signal };
        this.previous?.addEventListener('click', () => this.select(this.active - 1), options);
        this.next?.addEventListener('click', () => this.select(this.active + 1), options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.select(index), options));
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.update());
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const actions = { ArrowRight: this.active + 1, ArrowLeft: this.active - 1, Home: 0, End: this.cards.length - 1 };
          if (Object.hasOwn(actions, event.key)) {
            event.preventDefault();
            this.select(actions[event.key]);
          }
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.cards.findIndex(card => card.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.select(index, false);
        }, options);
        this.observer = new ResizeObserver(() => this.select(this.active, false));
        this.observer.observe(this.track);
        this.dataset.enhanced = '';
        this.select(this.active, false);
        this.navigation?.removeAttribute('hidden');
        this.previous?.removeAttribute('hidden');
        this.next?.removeAttribute('hidden');
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        cancelAnimationFrame(this.scrollFrame);
      }
      position(index) {
        const card = this.cards[index];
        const trackRect = this.track.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        return this.track.scrollLeft + cardRect.left + cardRect.width / 2 - trackRect.left - this.track.clientWidth / 2;
      }
      select(index, animate = true) {
        index = Math.max(0, Math.min(this.cards.length - 1, index));
        const behavior = animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant';
        this.track.scrollTo({ left: this.position(index), behavior });
        this.active = index;
        this.paint();
      }
      update() {
        let nearest = 0;
        let distance = Infinity;
        this.cards.forEach((card, index) => {
          const offset = Math.abs(this.position(index) - this.track.scrollLeft);
          if (offset < distance) { nearest = index; distance = offset; }
        });
        this.active = nearest;
        this.paint();
      }
      paint() {
        this.cards.forEach((card, index) => card.classList.toggle('is-current', index === this.active));
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.active)));
        if (this.previous) this.previous.disabled = this.active === 0;
        if (this.next) this.next.disabled = this.active === this.cards.length - 1;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aube-video-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aube-video-stories')) {
    customElements.define('aube-video-stories', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.cards = [...this.querySelectorAll('[data-card]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.stage = this.querySelector('[data-stage]');
        this.status = this.querySelector('[data-status]');
        if (!this.cards.length) return;
        this.index = Math.floor((this.cards.length - 1) / 2);
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.select(this.index - 1), { signal });
        this.querySelector('[data-next]')?.addEventListener('click', () => this.select(this.index + 1), { signal });
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.select(index), { signal }));
        this.cards.forEach((card, index) => {
          card.querySelector('[data-stop]')?.addEventListener('click', () => this.clearVideo(true), { signal });
          card.addEventListener('click', event => {
            if (event.target.closest('[data-player], [data-stop], a')) return;
            if (Date.now() < (this.suppressClickUntil || 0)) {
              event.preventDefault();
              return;
            }
            if (index !== this.index) {
              event.preventDefault();
              this.select(index);
            }
            this.openVideo(card);
          }, { signal });
        });
        this.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.target.closest('input, textarea, select, video')) return;
          if (event.key === 'Escape' && this.activeCard) {
            event.preventDefault();
            this.clearVideo(true);
            return;
          }
          let next;
          if (event.key === 'ArrowLeft') next = this.index - 1;
          if (event.key === 'ArrowRight') next = this.index + 1;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.cards.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          const focusOnCard = Boolean(event.target.closest('[data-card]'));
          this.select(next);
          if (focusOnCard) this.dots[this.index]?.focus({ preventScroll: true });
        }, { signal });
        this.stage.addEventListener('pointerdown', event => {
          this.pointer = null;
          if (event.target.closest('[data-player], [data-stop]')) return;
          if (!event.isPrimary || event.button !== 0) return;
          this.pointer = { x: event.clientX, y: event.clientY, id: event.pointerId };
        }, { signal });
        this.stage.addEventListener('pointerup', event => {
          if (!this.pointer || event.pointerId !== this.pointer.id) return;
          const dx = event.clientX - this.pointer.x;
          const dy = event.clientY - this.pointer.y;
          this.pointer = null;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
          this.suppressClickUntil = Date.now() + 350;
          this.select(this.index + (dx < 0 ? 1 : -1));
        }, { signal });
        this.stage.addEventListener('pointercancel', () => { this.pointer = null; }, { signal });
        this.stage.addEventListener('dragstart', event => event.preventDefault(), { signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.activeCard?.querySelector('video')?.pause();
        }, { signal });
        document.addEventListener('aube:story:play', event => {
          if (event.detail?.source !== this) this.clearVideo();
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const index = this.cards.findIndex(card => card.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.select(index);
        }, { signal });
        this.select(this.index, false);
        this.setAttribute('data-ready', '');
        this.visibilityObserver = new IntersectionObserver(entries => {
          if (!entries[0].isIntersecting) this.activeCard?.querySelector('video')?.pause();
        });
        this.visibilityObserver.observe(this.stage);
      }
      select(index, announce = true) {
        const count = this.cards.length;
        const nextIndex = ((index % count) + count) % count;
        if (this.activeCard && this.activeCard !== this.cards[nextIndex]) this.clearVideo();
        this.index = nextIndex;
        this.cards.forEach((card, position) => {
          let offset = (position - this.index + count) % count;
          if (offset > count / 2) offset -= count;
          card.dataset.offset = String(offset);
          card.toggleAttribute('data-far', Math.abs(offset) > 3);
          card.setAttribute('aria-hidden', String(offset !== 0));
          card.inert = Math.abs(offset) > 3;
          card.querySelectorAll('a, button').forEach(control => { control.tabIndex = offset === 0 ? 0 : -1; });
        });
        this.dots.forEach((dot, position) => {
          if (position === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (announce) this.status.textContent = this.cards[this.index].getAttribute('aria-label');
      }
      openVideo(card) {
        const template = card.querySelector('[data-video-template]');
        const player = card.querySelector('[data-player]');
        if (!template || !player || this.activeCard === card) return;
        this.clearVideo();
        document.dispatchEvent(new CustomEvent('aube:story:play', { detail: { source: this } }));
        player.replaceChildren(template.content.cloneNode(true));
        const video = player.querySelector('video');
        if (!video) return;
        this.activeCard = card;
        player.hidden = false;
        card.querySelector('[data-stop]').hidden = false;
        card.setAttribute('data-playing', '');
        video.addEventListener('ended', () => {
          if (this.activeCard === card) this.clearVideo(card.contains(document.activeElement));
        }, { signal: this.controller.signal });
        video.focus({ preventScroll: true });
        // Keep native controls available if the browser declines the first play request.
        video.play().catch(() => {});
      }
      clearVideo(restoreFocus = false) {
        const card = this.activeCard;
        if (!card) return;
        this.activeCard = null;
        const player = card.querySelector('[data-player]');
        player.querySelector('video')?.pause();
        player.replaceChildren();
        player.hidden = true;
        card.querySelector('[data-stop]').hidden = true;
        card.removeAttribute('data-playing');
        if (restoreFocus) card.querySelector('[data-play]')?.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        this.visibilityObserver?.disconnect();
        this.controller?.abort();
        this.controller = null;
        this.clearVideo();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
